import addEventListeners from './events/addEventListeners';
import forEachElement from './selectors/forEachElement';
import appendPlaceholderToSelect from './selectors/appendPlaceholderToSelect';
import * as I18n from './leadform-i18n';

const updateVariables = (e, targetFields) => {
  const value = e.target.value;
  // Check all data-text areas for possible replacement
  forEachElement(targetFields, elem => {
    const {text} = elem.dataset;
    if(text.indexOf('%{[') === -1) {
      elem.innerHTML = I18n.replaceTranslations(I18n.replaceVariables(text));
    } else {
      elem.innerHTML = text.replace(/(%{\[[\w\.\[\]]+})/g, value); // eslint-disable-line
    }
  });
};

const valueMatch = (varVal, eqVal, notEqVal) => {
  let match = false;
  if(eqVal) {
    for (let el of eqVal.split(',')) {
      if (el === varVal) {
        match = true;
        break;
      }
    }
  }
  if(!match && notEqVal) {
    let noMatchedValues = true;
    for (let el of notEqVal.split(',')) {
      if (el === varVal) {
        noMatchedValues = false;
        break;
      }
    }
    match = noMatchedValues;
  }
  return match;
};

const hideFields = (e, targetFields) => {
  const varValue = e.target.value;
  // Check all data-hide areas for possible replacement
  forEachElement(targetFields, elem => {
    const equalValue = elem.dataset.hide.split('==')[1];
    const notEqualValue = elem.dataset.hide.split('!=')[1];
    if(valueMatch(varValue, equalValue, notEqualValue)) {
      elem.style.display = 'none';
    } else {
      elem.removeAttribute('style');
    }
  });
};

const targetFields = (form, varName, selector = 'text') => {
  const allDataFields = form.querySelectorAll(`[data-${selector}]`);
  const matchedFields = [...allDataFields].reduce((memo, elem) => {
    if(elem.dataset[selector].indexOf(varName) > -1) {
      memo.push(elem);
    }
    return memo;
  }, []);
  return matchedFields;
};

export const setUpFormVariables = function(leadformWrapperSelector = '.js-leadform') {
  // Cycle through each leadform separately to handle multiple leadforms per page
  // (otherwise progressing 1 leadform progresses them all)
  forEachElement(leadformWrapperSelector, leadformWrapper => {
    const form = leadformWrapper.querySelector('form');
    const variableFields = form.querySelectorAll('[data-var]');

    // Add listener to every data-var
    forEachElement(variableFields, field => {
      const { name } = field;
      const matchedUpdateFields = targetFields(leadformWrapper, name);
      const matchedHideFields = targetFields(leadformWrapper, name, 'hide');
      const matchedFormFields = targetFields(leadformWrapper, name, 'depends');
      const eventType = field.type === 'select-one' ? 'change' : 'focusout';
      if(matchedUpdateFields.length > 0) {
        addEventListeners(field, eventType, function(e) {
          updateVariables(e, matchedUpdateFields);
        });
      }
      if(matchedHideFields.length > 0) {
        addEventListeners(field, eventType, function(e) {
          hideFields(e, matchedHideFields);
        });
        const ev = new Event('change');
        field.dispatchEvent(ev);
      }
      if (matchedFormFields.length > 0){
        addEventListeners(field, eventType, (e) => {
          replaceFormOptions(e, matchedFormFields);
        });
        field.dispatchEvent(new Event('change'));
      }
    });
  });
};

const replaceFormOptions = (e, targetFields) => {
  forEachElement(targetFields, elem => {
    while (elem.firstChild) {
      elem.removeChild(elem.firstChild);
    }

    if (elem.dataset.placeholder != null) {
      appendPlaceholderToSelect(elem, elem.dataset.placeholder);
    }

    let options;
    if(elem.dataset.list) {
      const optionsList = JSON.parse(elem.dataset.list);
      options = optionsList.find(
        option => option.depends_values.includes(e.target.value.toLowerCase())
      ).options;

      options.forEach(optionSetting => {
        const { value, target } = optionSetting;
        appendOptionToSelect(elem, value, target);
      });
    } else {
      options = I18n.retrieveFormSelectOptions(elem.name, e.target.value);
      options.forEach(value => appendOptionToSelect(elem, value));
    }

    elem.dispatchEvent(new Event('change'));
  });
};

const  appendOptionToSelect = (selectElement, value, target) => {
  let option = document.createElement('option');
  if (target) {
    option.setAttribute('data-target', target);
  }
  option.setAttribute('value', value);
  option.innerHTML = value;
  selectElement.appendChild(option);
};

module.exports = {
  setUpFormVariables: setUpFormVariables
};



// WEBPACK FOOTER //
// ./client/app/scripts/principles/leadform-variables.js